import React from 'react';
import { GraduationCap, Stethoscope, Check } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
const AUDIENCES = [{
  icon: GraduationCap,
  title: 'Si todavía estás estudiando',
  points: ['Conecta teoría y práctica.', 'Prepárate mejor para prácticas clínicas.', 'Aprende a relacionar hallazgos.'],
  rail: 'bg-clinic',
  iconTone: 'bg-clinic/12 border-clinic/35 text-clinic-dark',
  surface: 'bg-clinic/[0.04]'
}, {
  icon: Stethoscope,
  title: 'Si ya atiendes pacientes',
  points: ['Consulta pruebas y evaluaciones.', 'Organiza mejor tu razonamiento.', 'Amplía tus recursos terapéuticos.'],
  rail: 'bg-gold',
  iconTone: 'bg-gold/12 border-gold/40 text-gold-deep',
  surface: 'bg-gold/[0.04]'
}];
export function Audiences() {
  return <AnimatedSection className="bg-mist-100 py-9 sm:py-12" data-id="element-16" data-mp="1wwyoce73u9ig">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17" data-mp="20vec4kb0flwx">
        <h2 className="font-heading text-navy-950 tracking-tight text-[1.2rem] sm:text-[1.8rem] leading-[1.16] mb-4 sm:mb-6" data-id="element-18" data-mp="2d3hn5zxvss0z">
          <span className="font-extrabold" data-id="element-19" data-mp="283mx1ylxk6gz">Tanto si estás aprendiendo</span>{' '}
          <span className="font-editorial italic text-gold-deep font-medium" data-id="element-20" data-mp="2n2gzbshuv5sq">
            como si ya atiendes pacientes.
          </span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 sm:gap-3" data-id="element-21" data-mp="2i3m41r2pborq">
          {AUDIENCES.map(a => <article key={a.title} className={`relative overflow-hidden rounded-xl border border-navy-900/10 bg-white p-3.5 sm:p-4 shadow-[0_2px_12px_rgba(11,27,51,0.05)]`} data-id="element-22" data-mp="1ub5kfc3bfoqb">
              <span aria-hidden className={`absolute top-0 left-0 h-full w-[3px] ${a.rail}`} data-id="element-23" data-mp="1zccxnqo89g4d" />
              <span aria-hidden className={`absolute inset-0 ${a.surface} pointer-events-none`} data-id="element-24" data-mp="1blqp7yab9ttu" />

              <div className="relative flex items-center gap-2 mb-2.5" data-id="element-25" data-mp="16lutsnfojapw">
                <span className={`flex-shrink-0 w-8 h-8 rounded-lg border flex items-center justify-center ${a.iconTone}`} data-id="element-26" data-mp="1wbbbxhfj1st7">
                  <a.icon size={15} strokeWidth={2} data-id="element-27" data-mp="253mtsewks7xk" />
                </span>
                <h3 className="font-heading font-bold text-navy-950 text-[13px] sm:text-[15px] leading-tight" data-id="element-28" data-mp="2a380jbhzlkku">
                  {a.title}
                </h3>
              </div>

              <ul className="relative space-y-1" data-id="element-29" data-mp="1df1tkhxleg3e">
                {a.points.map(p => <li key={p} className="flex items-start gap-1.5 text-[12px] sm:text-[13.5px] text-navy-800/75 leading-snug" data-id="element-30" data-mp="1heu0kq7c8e6n">
                    <Check size={12} className="text-navy-800/45 flex-shrink-0 mt-[3px]" strokeWidth={3} data-id="element-31" data-mp="1reb697mlas2m" />
                    <span data-id="element-32" data-mp="32qbzayqhl2o6">{p}</span>
                  </li>)}
              </ul>
            </article>)}
        </div>
      </div>
    </AnimatedSection>;
}